import {useLayoutEffect, useState} from 'react';

/** @module hooks/use-window-size */

/**
 * Custom hook to get the current window dimensions (width and height)
 * @returns {{height: number, width: number}} The current window dimensions
 *
 * @memberof module:hooks/use-window-size
 */
const useWindowSize = () => {
    // Initialize state with undefined width/height so server and client renders match
    // More here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    /* eslint-disable no-undefined */
    const [size, setSize] = useState({
        width: undefined,
        height: undefined,
    });
    /* eslint-enable no-undefined */

    useLayoutEffect(() => {
        const handleResize = () => {
            setSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return size;
};

export default useWindowSize;
